import { FC } from "react";
import { Box } from "@mui/material";
import { Sort } from "./Sort";
import { FiletypeFilter } from "./FiletypeFilter";
import { DateRangeFilter } from "./DateFilter";
import { ToggleViews } from "./ToggleViews";
export type ControlsProps = {
  showFilters?: boolean;
};
export const Controls: FC<ControlsProps> = ({
  showFilters = true
}) => {
  return <Box sx={{
    px: 4,
    py: 2
  }} data-sentry-element="Box" data-sentry-component="Controls" data-sentry-source-file="Controls.tsx">
      <Box sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }} data-sentry-element="Box" data-sentry-source-file="Controls.tsx">
        <Box sx={{
        gap: 1.5,
        display: "flex",
        height: "28px"
      }} data-sentry-element="Box" data-sentry-source-file="Controls.tsx">
          {showFilters && <>
              <Sort />
              <FiletypeFilter />
              <DateRangeFilter />
            </>}
        </Box>
        <ToggleViews data-sentry-element="ToggleViews" data-sentry-source-file="Controls.tsx" />
      </Box>
    </Box>;
};